import React, { useEffect } from 'react';
import { connect,useDispatch } from 'react-redux';
import { compose } from 'redux';
import {getDataOnRequest} from '../redux/actions/CommonActions'
import { toast } from 'react-toastify';
const DocumentComplianceContainer = (OriginalComponent) => {
  const NewComponent = (props) => {
    const dispatch = useDispatch();
    useEffect(()=>{
      toast.dismiss();
      if(props.userAuth.users_access_token && props.documentCompliance.length === 0)
        dispatch(getDataOnRequest(props.userAuth.users_access_token,'SetDocumentCompliance','SET_DOCUMENT_COMPLIANCE'))
   }, [props.userAuth.users_access_token, props.documentCompliance.length, dispatch])

    return (
      <OriginalComponent {...props}  />
    )
  }
  return NewComponent
}

const mapStateToProps = (state) => {
  return {
    documentCompliance:state.documentCompliance.documentCompliance,
    userAuth:state.auth.authUserData,
    userInfo:state.userProfile.userData
  };
};

const composedDocumentComplianceContainer = compose(connect(mapStateToProps), DocumentComplianceContainer)
export default composedDocumentComplianceContainer;

